import { http } from './http';
import type { ApiSuccess } from './types';
import type { PermissionKey } from '@auth/types';

export interface PermissionDto {
  id: number;
  key: PermissionKey;
  label: string;
  description: string | null;
}

export const permissionsApi = {
  async list(): Promise<PermissionDto[]> {
    const res = await http.get<ApiSuccess<PermissionDto[]>>('/api/permissions');
    return res.data.data;
  },
};
